import type { MatchRules } from "./ability";
import { recordInput } from "./command";
import { resolveHits, separate } from "./combat";
import type { SimEvent } from "./events";
import { faceOpponent, updateFighter } from "./fighter";
import type { InputBits } from "./input";
import { updateRound } from "./round";
import { PHASE, type MatchState } from "./state";
import { updateShots } from "./projectile";
import { updateThrow } from "./throw";
import { checkDecisive, slowFrame } from "./decisive";
import { checkOpener, updateCinematic } from "./super";

/**
 * Один шаг мира, 1/60 с. Только целые числа, без времени и DOM: одинаковые нажатия дают одинаковый мир
 * у обоих игроков (GAME-02) — на этом стоит откат кадров в сети.
 */
export function step(state: MatchState, rules: MatchRules, frameInputs: readonly [InputBits, InputBits]): SimEvent[] {
  const events: SimEvent[] = [];
  const emit = (event: SimEvent): void => {
    events.push(event);
  };
  state.frame++;
  // решающий удар: мир идёт медленнее — кадры между обработанными стоят, нажатия копятся (sim/decisive.ts)
  const inputs: [InputBits, InputBits] = [frameInputs[0], frameInputs[1]];
  if (slowFrame(state, inputs)) return events;
  const [a, b] = state.fighters;
  recordInput(a, inputs[0]);
  recordInput(b, inputs[1]);
  // простой для авто-издёвки считается только в бою: заставка раунда — не простой
  if (state.phase !== PHASE.fight) {
    a.quiet = 0;
    b.quiet = 0;
  }
  if (state.hitstop > 0) {
    state.hitstop--;
    return events;
  }
  // заставка суперприёма: мир стоит, идёт сцена
  if (state.cinematic >= 0) {
    updateCinematic(state, rules, events);
    if (state.cinematic < 0) updateRound(state, rules, events);
    return events;
  }
  const canAct = state.phase === PHASE.fight;
  updateFighter(a, b, inputs[0], rules, 0, canAct, state.frame, emit);
  updateFighter(b, a, inputs[1], rules, 1, canAct, state.frame, emit);
  separate(state, rules);
  faceOpponent(a, b);
  faceOpponent(b, a);
  if (state.phase === PHASE.fight) {
    resolveHits(state, rules, events);
    checkOpener(state, rules, events);
  }
  updateShots(state, rules, events);
  updateThrow(state, rules, events);
  updateRound(state, rules, events);
  checkDecisive(state, rules, events);
  return events;
}
